/**
 * Distributions API Service
 * Handles all distribution-related API calls
 */

import apiClient from './index.js';

export class DistributionsApi {
  /**
   * Get list of distributions
   */
  static async getDistributions(token) {
    return apiClient.get('/create/v1/distributions', token);
  }

  /**
   * Get distribution details
   * @param {string} token - Auth token
   * @param {string} relId - Distribution relId
   */
  static async getDistributionDetails(token, relId) {
    return apiClient.get(`/create/v1/distributions/details?relId=${relId}`, token);
  }

  /**
   * Add a new distribution
   * @param {string} token - Auth token
   * @param {Object} distributionData - Distribution data
   */
  static async addDistribution(token, distributionData) {
    return apiClient.post('/create/v1/distributions', token, distributionData);
  }

  /**
   * Update distribution
   * @param {string} token - Auth token
   * @param {Object} updateData - Update data
   */
  static async updateDistribution(token, updateData) {
    return apiClient.patch('/create/v1/distributions', token, updateData);
  }

  /**
   * Delete distribution
   * @param {string} token - Auth token
   * @param {string} distributionId - Distribution ID
   */
  static async deleteDistribution(token, distributionId) {
    // No dedicated delete route yet; use update with cancel or implement when available
    return apiClient.patch('/create/v1/distributions', token, { type: 'cancel', relId: distributionId });
  }

  /**
   * Trigger scheduled distribution
   * @param {string} token - Auth token
   * @param {Object} scheduleData - Schedule data
   */
  static async triggerScheduled(token, scheduleData) {
    return apiClient.post('/create/v1/distributions', token, scheduleData);
  }

  /**
   * Get distribution progress
   * @param {string} token - Auth token
   * @param {string} distributionId - Distribution ID
   */
  static async getDistributionProgress(token, distributionId) {
    return apiClient.get(`/create/v1/distributions/progress?relId=${distributionId}`, token);
  }
}

export default DistributionsApi;
